import {BaseFormModel} from './base-form-model';

export class OrganizationSummary extends BaseFormModel<OrganizationSummary> {
    orgId: number;
    average: number;
    unread: number;
}
